import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DropDownRequest, DropDownResponse, RequirmentTypeModel, WHLocationModel, DesignationModel } from '../../models/DropDwon/DropDownRequest';
import { ToastrService } from 'ngx-toastr';
import { DemoSampleAllocationService } from '../../Services/DemoSampleAllocation/demo-sample-allocation.service';
import { RoleCodeModel, EmployeeNameModel, DemoSampleAllocationDetails, FilterModel } from '../../models/DemoSampleAllocation/demo-sample-allocation-details';
import { DropDownService } from '../../Services/DropDown/dropdownService';
import { RegionModel } from '../../models/DropDwon/RegionModel';
import { ZoneModel } from '../../models/DropDwon/ZoneModel';
import { DivisionModel } from '../../models/DropDwon/DvisionModel';
import { SBUModel } from '../../models/DropDwon/SBUModel';
import { FormsModule } from '@angular/forms';
import { AnnualRequirement } from '../../Models/AnnualRequirement/annual-requirement';
import { PagerService } from '../../Services/pager.service';
import { ignoreElements } from 'rxjs-compat/operator/ignoreElements';
import { productModel } from '../../Models/DropDwon/ProductModel';
import { DatePipe } from '@angular/common';
import { YearModel } from 'src/app/Models/DropDwon/YearModel';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-demo-sample-allocation',
  templateUrl: './demo-sample-allocation.component.html',
  styleUrls: ['./demo-sample-allocation.component.css']
})
export class DemoSampleAllocationComponent implements OnInit {
  loader = 'none';
  public userId: string;
  public roleId: string;
  @ViewChild('regionSelect') regionSelect;
  @ViewChild('sbu') sbu;
  @ViewChild('division') division;
  @ViewChild('zone') zone;
  @ViewChild('WHLocationItem') WHLocationItem;
  @ViewChild('file') file;
  @ViewChild('employeeSelect') employeeSelect
  @ViewChild('roleCodeModel') roleCodeModel
  @ViewChild('requirmentType') requirmentType
  @ViewChild('designSelect') designSelect;
  @ViewChild('yearSelect') yearSelect;
  @ViewChild('year') year;

  //public requirmentType: RequirmentTypeModel[];
  // public roleCodeModel: RoleCodeModel[];
  public roleCodeModelddl: RoleCodeModel[];
  public employeeNameModel: EmployeeNameModel[];
  //public demoSampleAllocationModel: DemoSampleAllocationDetails[];
  public demoSampleAllocationModel: any;
  public roleSettings = {};
  dropdownEmployeeNameSettings: any = {};
  dropdownRoleCodeSettings: any = {};
  selectedEmployees: any[] = [];

  public dropdownMonthSettings: {};

  public RegionSettings = {};
  public RegionselectedItems: RegionModel[];

  public SBUSettings = {};
  public SBUSelectedItem: SBUModel[];

  public DivisionSettings = {};
  public DivisionSelectedItem: DivisionModel[];

  public ZoneSettings = {};
  public ZoneSelectedItem: ZoneModel[];

  public FlagDropDown: string;

  public ddlRequest: DropDownRequest = new DropDownRequest();
  public ddlResponse: DropDownResponse = new DropDownResponse();

  public RequirmentTypeSettings = {};
  public RoleCodeTypeSettings = {};
  public requirmentTypeDdl: RequirmentTypeModel[];
  public requirmentDllValue: any;

  public WHLocationSettings = {};
  public whLocationDdl: WHLocationModel[];
  public whLocationDDlValue: any;

  public YearSettings= {};
  public YearSelectedItem: YearModel[];

  approvefinalReqDetails: any[] = [];
  reqType: string;
  regionCode: string;
  wareHouseLocation: string;
  selectedReqType: any[] = [];
  selectedRegion: any[] = [];
  selectedRoleCode: any[] = [];
  selectedSbu: any[] = [];
  selectedDivision: any[] = [];
  selectedZone: any[] = [];
  commaSeperatedSbus: string;
  commaSeperatedDivisions: string;
  commaSeperatedZones: string;
  commaSeperatedRegions: string;
  sumOfPackOfOneRow: number = 0;
  commaSeperatedEmployees: string;
  commaSeperatedRoleCode: string;
  commaSeperatedReqType: string;
  selectedRole: string;
  userName: string;
  public isViewOnly: string;
  schemeFromRange: any;
  schemeToRange: any;
  files: File[] = [];
  fileName: string = '';
  document: AnnualRequirement = new AnnualRequirement();
  public demoRequestModel: FilterModel = new FilterModel();
  isSubmitted: string = "false";
  //Start: varibales for pagination
  pager: any = {};
  model: any[];
  totalNoOfPacks: any[];
  pageSetting: number = 10;
  modalSetting: number = 0;
  modelFilter: any[];
  modelDepandent: any[];
  selectedPaging: any;
  //END: varibales for pagination
  displayReject = 'none';
  defaultValue = 'none';

  totalRecord: any;
  currentPage: any;
  lastPage: any;
  isDisabledPrevious = true;
  isDisabledNext = false;
  defaultView: boolean = true;
  recordsOnCurrentPage: any = 10;
  currentDate = new Date();
  startRecord: any = 1;
  pagination: any[];
  selectedRegionMessage: any[] = [];
  isSubmittedData: boolean = false;
  public dispatchStatusDDL: any;
  @ViewChild('dispatchStatus') dispatchStatus;
  public DispatchStatusSettings = {};
  commaSeperatedStatus: string;
  selectedStatusType: any[] = [];
  public ProductSettings = {};
  public ProductSelectedItem: productModel[];
  @ViewChild('productSelect') productSelect;
  selectedProduct: any[] = [];
  commaSeperatedProduct: string;
  displayEdit = 'none';
  editStockIn: any = {};
  tempStock: any = {};
  currentMonth: any;
  originalRemainQTY: number = 0;
  isPopDisable: boolean = false;
  totalRemainingQuantity: string;


  public DesignationSettings = {};
  public designationddl: DesignationModel[];
  public designationDllValue: any;

  constructor(private toastr: ToastrService, private demoSampleAllocationService: DemoSampleAllocationService, private ddlServices: DropDownService, private _pagerService: PagerService
    , private datePipe: DatePipe) {
    this.userId = localStorage.getItem('dsu_userId');
    this.roleId = localStorage.getItem('dsu_roleId');
    this.userName = localStorage.getItem('dsu_userName');
    this.isViewOnly = localStorage.getItem('dsu_isViewOnly');
    this.FlagDropDown = (this.roleId == "39" || this.roleId == "43" || this.roleId == "77" || this.roleId == "44") ? "Supervisor" : "DEFAULT";
  }

  ngOnInit() {
    let currentDate = new Date();
    this.currentMonth = currentDate.getMonth() + 1;
    this.selectedRole = '0';
    this.selectedPaging = '0';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.dispatchStatusDDL = [{ id: 1, text: "Allocate Demo Sample" }, { id: 2, text: "Demo Sample Stock out to field team" }]
    this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {

          this.ddlResponse = response.data;
          if(document.getElementsByClassName('mobile-hide-add').length>0){
           // this.onRegionSelectAllForMob(this.ddlResponse.region);
            this.onStatusTypeSelectForMob(this.dispatchStatusDDL);
          }
          this.ddlResponse.year=response.data.year;
                    class YearItemList{
                        id: any;
                        text: any;
                    }
                      let requiredItem: YearItemList[] = [];
                      var obj = {
                        id : this.ddlResponse.year[0].currentrequirementYear,
                        text: this.ddlResponse.year[0].currentrequirementYear
                      }
                      requiredItem.push(obj)
                      this.year.selectedItems = requiredItem
                      for(var i=0;i<this.year.selectedItems.length; i++){
                          this.yearSelect.push(this.year.selectedItems[i].text)
                      }
                    this.YearSetting();

          
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
      });
    this.SBUMHSetting();
    this.DivisionSetting();
    this.ZoneSetting();
    this.RegionSetting();
    this.requirmentTypeDdl = [{ id: 1, text: "H1" }, { id: 2, text: "H2" }, { id: 3, text: "Additional" }];
    this.roleCodeModelddl = [{ RoleID: 1, RoleCode: "TMH" }, { RoleID: 2, RoleCode: "UMH" }];
    this.RoleCodeTypeSetting();
    this.RequirmentTypeSetting();
    this.WHLocation();
    this.WHLocationSetting();
    let today = new Date();
    let date = today.getDate();
    let month = today.getMonth();
    var year = today.getFullYear();
    this.schemeFromRange = year;
    this.schemeToRange = year;
    this.DispatchedStatusSetting();
    this.ProductSetting();
    this.DesignationSetting();
    this.YearSetting();
   // if(localStorage.getItem('dsu_roleId') =='76')
    // {
    

   this.designationddl = [{ id: 1, text: "MIO" }, { id: 2, text: "MDO" }, { id: 3, text: "MIE" },{id:4, text: "MC"},{id:5, text: "TM"},{id:6, text: "RBM/RMH"},{id:7, text: "RSH"}];
   // }
   // else{

   // this.designationddl = [{ id: 1, text: "MIO" }, { id: 2, text: "MDO" }, { id: 3, text: "MIE" },{id:4, text: "MC"},{id:6, text: "RBM/RMH"}];
   //}

  }
  ProductSetting() {
    this.ProductSettings = {
      singleSelection: false,
      idField: 'productId',
      textField: 'productName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Product Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  YearSetting(){
    this.YearSettings = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Year Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }


  DispatchedStatusSetting() {
    this.DispatchStatusSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'text',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Dispatch Status Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  RegionSetting() {
    this.RegionSettings = {
      singleSelection: false,
      idField: 'regionCode',
      textField: 'regionName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      //maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Region Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  SBUMHSetting() {
    this.SBUSettings = {
      singleSelection: false,
      idField: 'sbuCode',
      textField: 'sbuName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No SBU Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  DivisionSetting() {
    this.DivisionSettings = {
      singleSelection: false,
      idField: 'divisionCode',
      textField: 'divisionName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Division Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  ZoneSetting() {
    this.ZoneSettings = {
      singleSelection: false,
      idField: 'zoneCode',
      textField: 'zoneName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Zone Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  RequirmentTypeSetting() {
    this.RequirmentTypeSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'text',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Requirment Type Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  RoleCodeTypeSetting() {
    this.RoleCodeTypeSettings = {
      singleSelection: false,
      idField: 'RoleID',
      textField: 'RoleCode',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No User Type Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  WHLocationSetting() {
    this.WHLocationSettings = {
      singleSelection: true,
      idField: 'WHId',
      textField: 'WHName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Location Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  DesignationSetting() {
    this.DesignationSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'text',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Designation Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  WHLocation() {
    this.whLocationDdl = [{ WHId: '1', WHName: "WHName1" }, { WHId: '2', WHName: "WHName2" }]
  }

  public onProductSelect(item: any) {
    this.selectedProduct = [];
    for (var i = 0; i < this.productSelect.selectedItems.length; i++) {
      this.selectedProduct.push(this.productSelect.selectedItems[i].id)
    }
    this.commaSeperatedProduct = this.selectedProduct.join(", ");
  }
  public onProductDeSelect(item: any) {
    this.selectedProduct = [];
    for (var i = 0; i < this.productSelect.selectedItems.length; i++) {
      this.selectedProduct.push(this.productSelect.selectedItems[i].id)
    }
    this.commaSeperatedProduct = this.selectedProduct.join(", ");
  }

  public onProductSelectAll(items: any) {
    this.selectedProduct = [];
    for (var i = 0; i < this.productSelect.selectedItems.length; i++) {
      this.selectedProduct.push(this.productSelect.selectedItems[i].id)
    }
    this.commaSeperatedProduct = this.selectedProduct.join(", ");
  }
  public onProductDeSelectAll(items: any) {
    this.selectedProduct = [];
    this.commaSeperatedProduct = '';
  }

  public onSBUSelect(item: any) {
    this.selectedSbu = [];
    for (var i = 0; i < this.sbu.selectedItems.length; i++) {
      this.selectedSbu.push(this.sbu.selectedItems[i].id)
    }
    this.commaSeperatedSbus = this.selectedSbu.join(", ");
    this.GetSBUWiseData(this.sbu.selectedItems);
  }
  public onSBUDeSelect(item: any) {
    this.selectedSbu = [];
    for (var i = 0; i < this.sbu.selectedItems.length; i++) {
      this.selectedSbu.push(this.sbu.selectedItems[i].id)
    }
    this.commaSeperatedSbus = this.selectedSbu.join(", ");

    this.GetSBUWiseData(this.sbu.selectedItems);
  }

  public onSBUSelectAll(items: any) {
    this.selectedSbu = [];
    for (var i = 0; i < this.sbu.selectedItems.length; i++) {
      this.selectedSbu.push(this.sbu.selectedItems[i].id)
    }
    this.commaSeperatedSbus = this.selectedSbu.join(", ")
    this.GetSBUWiseData(this.sbu.selectedItems);
  }
  public onSBUDeSelectAll(items: any) {
    this.selectedSbu = [];
    this.commaSeperatedSbus = '';
    this.GetSBUWiseData(this.sbu.selectedItems);
  }

  public onDivisionSelect(item: any) {
    this.selectedDivision = []
    for (var i = 0; i < this.division.selectedItems.length; i++) {
      this.selectedDivision.push(this.division.selectedItems[i].id)
    }
    this.commaSeperatedDivisions = this.selectedDivision.join(", ");
    this.GetDivisionWiseData(this.division.selectedItems);

  }
  public onDivisionDeSelect(item: any) {
    this.selectedDivision = []
    for (var i = 0; i < this.division.selectedItems.length; i++) {
      this.selectedDivision.push(this.division.selectedItems[i].id)
    }
    this.commaSeperatedDivisions = this.selectedDivision.join(", ")
    this.GetDivisionWiseData(this.division.selectedItems);
  }

  public onDivisionSelectAll(items: any) {
    this.selectedDivision = []
    for (var i = 0; i < this.division.selectedItems.length; i++) {
      this.selectedDivision.push(this.division.selectedItems[i].id)
    }
    this.commaSeperatedDivisions = this.selectedDivision.join(", ")
    this.GetDivisionWiseData(this.division.selectedItems);
  }
  public onDivisionDeSelectAll(items: any) {
    this.selectedDivision = [];
    this.commaSeperatedDivisions = '';
    this.GetDivisionWiseData(this.division.selectedItems);
  }

  public onZoneSelect(item: any) {
    this.selectedZone = [];
    for (var i = 0; i < this.zone.selectedItems.length; i++) {
      this.selectedZone.push(this.zone.selectedItems[i].id)
    }
    this.commaSeperatedZones = this.selectedZone.join(", ");

    this.GetZoneWiseData(this.zone.selectedItems);
  }
  public onZoneDeSelect(item: any) {
    this.selectedZone = [];
    for (var i = 0; i < this.zone.selectedItems.length; i++) {
      this.selectedZone.push(this.zone.selectedItems[i].id)
    }
    this.commaSeperatedZones = this.selectedZone.join(", ");
    this.GetZoneWiseData(this.zone.selectedItems);
  }

  public onZoneSelectAll(items: any) {
    this.selectedZone = [];
    for (var i = 0; i < this.zone.selectedItems.length; i++) {
      this.selectedZone.push(this.zone.selectedItems[i].id)
    }
    this.commaSeperatedZones = this.selectedZone.join(", ");
    this.GetZoneWiseData(this.zone.selectedItems);
  }
  public onZoneDeSelectAll(items: any) {
    this.selectedZone = [];
    this.commaSeperatedZones = '';
    this.GetZoneWiseData(this.zone.selectedItems);
  }
  public onRegionSelect(item: any) {
    this.selectedRegion = [];
    for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
      this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
    }
    this.commaSeperatedRegions = this.selectedRegion.join(", ");
    this.GetRegionWiseData(this.regionSelect.selectedItems);
    if (this.commaSeperatedRoleCode == undefined) {
      this.commaSeperatedRoleCode = '';
    }
    //this.getEmployeeName(this.commaSeperatedRoleCode)
  }
  public onRegionDeSelect(item: any) {
    this.selectedRegion = [];
    for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
      this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
    }
    this.commaSeperatedRegions = this.selectedRegion.join(", ");
    this.GetRegionWiseData(this.regionSelect.selectedItems);
    if (this.commaSeperatedRoleCode == undefined) {
      this.commaSeperatedRoleCode = '';
    }
    // this.getEmployeeName(this.commaSeperatedRoleCode)
  }

  public onStatusTypeSelectForMob(item: any) {
    
    class StatusItemList{
      id: number;
      text: string;
  }
    let requiredItem: StatusItemList[] = [];
    var obj = {
      id : item[0].id,
      text: item[0].text
    }
    requiredItem.push(obj)
  this.dispatchStatus.selectedItems = requiredItem
    for (var i = 0; i < this.dispatchStatus.selectedItems.length; i++) {
      this.selectedStatusType.push(this.dispatchStatus.selectedItems[i].text)
    }
    this.commaSeperatedStatus = this.selectedStatusType.join(", ");
    this.DispatchedStatusSetting();
  }

  public onRegionSelectAllForMob(items: any) {
    class RegionItemList{
      id: number;
      text: string;
  }
    let requiredItem: RegionItemList[] = [];
    for(let i=0; i<items.length;i++){
    var obj = {
      id : items[i].regionCode,
      text: items[i].regionName
    }
    requiredItem.push(obj)
    }
  this.regionSelect.selectedItems = requiredItem


    for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
      this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
    }
    this.commaSeperatedRegions = this.selectedRegion.join(", ");
    this.GetRegionWiseData(this.regionSelect.selectedItems);
    if (this.commaSeperatedRoleCode == undefined) {
      this.commaSeperatedRoleCode = '';
    }
    //this.getEmployeeName(this.commaSeperatedRoleCode)
  }
  
  public onRegionSelectAll(items: any) {
    this.selectedRegion = [];
    for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
      this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
    }
    this.commaSeperatedRegions = this.selectedRegion.join(", ");
    this.GetRegionWiseData(this.regionSelect.selectedItems);
    if (this.commaSeperatedRoleCode == undefined) {
      this.commaSeperatedRoleCode = '';
    }
    //this.getEmployeeName(this.commaSeperatedRoleCode)
  }
  public onRegionDeSelectAll(items: any) {
    this.selectedRegion = [];
    this.commaSeperatedRegions = '';
    this.GetRegionWiseData(this.regionSelect.selectedItems);
    if (this.commaSeperatedRoleCode == undefined) {
      this.commaSeperatedRoleCode = '';
    }
    // this.getEmployeeName(this.commaSeperatedRoleCode)
  }
  GetSBUWiseData(filter: any) {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.SBU = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getSBUHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.division = response.data.division;
          this.ddlResponse.zone = response.data.zone;
          this.ddlResponse.region = response.data.region;

          this.division.selectedItems = response.data.division.map(item => { return { id: item.divisionCode, text: item.divisionName } });
          this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          //this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {

      });
  }
  GetDivisionWiseData(filter: any) {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Division = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getDivisionHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.region = response.data.region;
          this.ddlResponse.zone = response.data.zone;

          this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          //this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });


        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {

      });
  }
  GetZoneWiseData(filter: any) {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Zone = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.region = response.data.region;

          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {

      });
  }
  ConvertToCurrency(value:any)
  {
      var parts = value.toString().replace(',','').split(".");
      if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
      }
      return parts.join(".");
  }

  GetRegionWiseData(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Region = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getRegionWiseRMHDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.rmh = response.data.rmh;
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {

        this.loader = 'none';
      });
  }

  onReqTypeSelect(item: any) {
    this.selectedReqType = [];
    for (var i = 0; i < this.requirmentType.selectedItems.length; i++) {
      this.selectedReqType.push(this.requirmentType.selectedItems[i].text)
    }
    this.commaSeperatedReqType = this.selectedReqType.join(", ");
    this.RequirmentTypeSetting();
  }

  onReqTypeDeSelect(item: any) {
    this.selectedReqType = [];
    this.commaSeperatedReqType = '';
  }

  onStatusTypeSelect(item: any) {
    this.selectedStatusType = [];
    for (var i = 0; i < this.dispatchStatus.selectedItems.length; i++) {
      this.selectedStatusType.push(this.dispatchStatus.selectedItems[i].text)
    }
    this.commaSeperatedStatus = this.selectedStatusType.join(", ");
    this.DispatchedStatusSetting();
  }

  onStatusTypeDeSelect(item: any) {
    this.selectedStatusType = [];
    this.commaSeperatedStatus = '';
  }

  onRoleCodeSelect(item: any) {
    // this.selectedRole = item.RoleCode;
    this.selectedRoleCode = [];
    for (var i = 0; i < this.roleCodeModel.selectedItems.length; i++) {
      this.selectedRoleCode.push(this.roleCodeModel.selectedItems[i].text)
    }
    this.commaSeperatedRoleCode = this.selectedRoleCode.join(", ");
    // if(this.selectedRoleCode.length >1){
    //   this.selectedRole='';
    // }
    // else{
    //   this.selectedRole = item.RoleCode;
    // }
    this.getEmployeeName(this.commaSeperatedRoleCode);
  }
  onRoleCodeDeSelect(item: any) {
    this.selectedRoleCode = [];
    for (var i = 0; i < this.roleCodeModel.selectedItems.length; i++) {
      this.selectedRoleCode.push(this.roleCodeModel.selectedItems[i].text)
    }
    this.commaSeperatedRoleCode = this.selectedRoleCode.join(", ");
    // if(this.selectedRoleCode.length >1 ){
    //   this.selectedRole='';
    // }
    // else if(this.selectedRoleCode.length =0 ){
    //   this.selectedRole='';
    // }
    // else{
    //   if(item.RoleCode == 'TMH'){
    //     this.selectedRole='UMH';
    //   }
    //   else if(item.RoleCode == 'UMH'){
    //     this.selectedRole='TMH';
    //   }
    //   else{
    //     this.selectedRole='';
    //   }
    //this.selectedRole=item.RoleCode;
    //}
    this.getEmployeeName(this.commaSeperatedRoleCode);
  }
  onRoleCodeSelectAll(item: any) {
    this.selectedRoleCode = [];
    for (var i = 0; i < this.roleCodeModel.selectedItems.length; i++) {
      this.selectedRoleCode.push(this.roleCodeModel.selectedItems[i].text)
    }
    this.commaSeperatedRoleCode = this.selectedRoleCode.join(", ");
    // if(this.selectedRoleCode.length >1){
    //   this.selectedRole = 'All';
    // }
    // else{
    //   this.selectedRole = item.RoleCode;
    // }

    this.getEmployeeName(this.commaSeperatedRoleCode);
  }
  onRoleCodeDeSelectAll() {
    this.selectedRoleCode = [];
    this.commaSeperatedRoleCode = '';
    this.getEmployeeName(this.commaSeperatedRoleCode);
  }

  getEmployeeName(selectedRole) {
    this.loader = 'block';
    if (this.commaSeperatedSbus == undefined) {
      this.commaSeperatedSbus = '';
    }
    if (this.commaSeperatedDivisions == undefined) {
      this.commaSeperatedDivisions = '';
    }
    if (this.commaSeperatedZones == undefined) {
      this.commaSeperatedZones = '';
    } if (this.commaSeperatedRegions == undefined) {
      this.commaSeperatedRegions = '';
    }
    this.demoSampleAllocationService.getEmployeeName(this.userId, this.roleId, this.commaSeperatedSbus, this.commaSeperatedDivisions, this.commaSeperatedZones, this.commaSeperatedRegions, this.commaSeperatedRoleCode)
      .subscribe((employeeData) => {
        this.employeeNameModel = employeeData.data;
        this.bindEmployeeDropdown(this.employeeNameModel);
        this.loader = 'none';

      });
  }
  bindEmployeeDropdown(selectedProduct: any): void {

    this.bindEmployeeDropdownSetting();

  }
  bindEmployeeDropdownSetting() {
    let isSingleSelection: boolean = false;
    isSingleSelection = false;

    this.dropdownEmployeeNameSettings = {
      singleSelection: isSingleSelection,
      idField: 'tmhCode',
      textField: 'tmhEmployeeName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }

  getDemoSampleAllocationDetails() {
    let region = ''
    if (typeof (this.commaSeperatedReqType) == "undefined" || this.commaSeperatedReqType == '') {
      this.toastr.error('Please select requirement type.');
      this.loader = 'none';
      return false;
    }
    if (this.regionSelect.selectedItems.length > 0) {
      region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
    }
    else {
      this.toastr.error('Please select region.');
      this.loader = 'none';
      return false;
    }
    if(document.getElementsByClassName('mobile-hide-add').length==0){
    if (typeof (this.commaSeperatedStatus) == "undefined" || this.commaSeperatedStatus == '') {
      this.toastr.error('Please select status.');
      this.loader = 'none';
      return false;
    }
  }else{
    this.commaSeperatedStatus="";
  }
    this.loader = 'block';
    if (this.commaSeperatedSbus == undefined) {
      this.commaSeperatedSbus = '';
    }
    if (this.commaSeperatedDivisions == undefined) {
      this.commaSeperatedDivisions = '';
    }
    if (this.commaSeperatedZones == undefined) {
      this.commaSeperatedZones = '';
    } if (this.commaSeperatedRegions == undefined) {
      this.commaSeperatedRegions = '';
    }
    if (this.commaSeperatedRoleCode == undefined) {
      this.commaSeperatedRoleCode = '';
    }
    if (this.commaSeperatedEmployees == undefined) {
      this.commaSeperatedEmployees = '';
    }
    if (this.commaSeperatedStatus == undefined) {
      this.commaSeperatedStatus = '';
    }
    if (this.commaSeperatedProduct == undefined) {
      this.commaSeperatedProduct = '';
    }
    
    let designation = Array.prototype.map.call(this.designSelect.selectedItems, function (item) { return item.text; }).join(",");
    //this.commaSeperatedStatus ='Demo Sample Stock Out To Field Team'
    this.model = [];
    let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.demoSampleAllocationService.getDemoSampleAllocationDetails(this.userId, this.roleId,
      this.commaSeperatedSbus, this.commaSeperatedDivisions, this.commaSeperatedZones,
      this.commaSeperatedRegions, this.commaSeperatedReqType, this.commaSeperatedRoleCode,
      this.commaSeperatedEmployees, this.commaSeperatedStatus, this.commaSeperatedProduct, designation,year)
      .subscribe((details) => {
        
        this.defaultValue = 'block';
        this.demoSampleAllocationModel = details.data;

        //this.tempModel={...details.data};
        // console.log(details.data)

        if (this.demoSampleAllocationModel == null || this.demoSampleAllocationModel.length == 0) {
          this.defaultValue = 'none';
          this.toastr.error('No record found.');
          this.loader = 'none';
          return false;
        }
        this.model = details.data;
        this.totalNoOfPacks=[];
        for(let i = 0; i<this.model.length; i++){
          let foundIndex = -1;
          const foundObject = this.totalNoOfPacks.find((obj, index) => {
            if (obj.Product === this.model[i].product) {
              foundIndex = index;
              return true;
            }
            return false;
          });

          if (foundObject) {
          // Object found, update Packs
          this.totalNoOfPacks[foundIndex].Packs += this.model[i].totalQtyToDispatch;
          } else {
          // Object not found, insert new object
          this.totalNoOfPacks.push({ Product: this.model[i].product, Packs: this.model[i].totalQtyToDispatch });
          }          
        }
        //this.setPage(1, this.pageSetting);
        this.loader = 'none';
        this.selectedRegionMessage = [];
        if (this.demoSampleAllocationModel != null) {
          this.selectedRegionMessage.push({ region: this.demoSampleAllocationModel[0].region, isAllocated: this.demoSampleAllocationModel[0].isAllocated })
          for (var i = 0; i < this.demoSampleAllocationModel.length; i++) {

            for (var j = 0; j < this.selectedRegionMessage.length; j++) {
              if (this.selectedRegionMessage[j].region == this.demoSampleAllocationModel[i].region) {
                break;
              }

            }
            if (j == this.selectedRegionMessage.length) {
              this.selectedRegionMessage.push({ region: this.demoSampleAllocationModel[i].region, isAllocated: this.demoSampleAllocationModel[i].isAllocated })
            }
          }
        }


        if (this.selectedRegionMessage.length >= 1) {
          for (var i = 0; i < this.selectedRegionMessage.length; i++) {
            if (this.selectedRegionMessage[i].isAllocated == 1) {
              this.isSubmittedData = true;
            } else {
              this.isSubmittedData = false;
            }

          }
        } else {
          this.isSubmittedData = false;
        }

      });

  }


  onEmployeeSelect(item: any) {
    this.selectedEmployees = [];
    for (var i = 0; i < this.employeeSelect.selectedItems.length; i++) {
      this.selectedEmployees.push(this.employeeSelect.selectedItems[i].id)
    }
    this.commaSeperatedEmployees = this.selectedEmployees.join(", ");
  }
  onEmployeeSelectAll(item: any) {
    this.selectedEmployees = [];
    for (var i = 0; i < this.employeeSelect.selectedItems.length; i++) {
      this.selectedEmployees.push(this.employeeSelect.selectedItems[i].id)
    }
    this.commaSeperatedEmployees = this.selectedEmployees.join(", ");

  }
  onEmployeeDeSelect(item: any) {
    this.selectedEmployees = [];
    for (var i = 0; i < this.employeeSelect.selectedItems.length; i++) {
      this.selectedEmployees.push(this.employeeSelect.selectedItems[i].id)
    }
    this.commaSeperatedEmployees = this.selectedEmployees.join(", ");

  }
  onEmployeeDeSelectAll(item: any) {
    this.selectedEmployees = [];
    this.commaSeperatedEmployees = '';

  }
  downloadExcel() {
    let today = new Date();
    let region = ''
    let month;
    let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    if((today.getMonth() + 1)<10)
    {
        month = '0' + (today.getMonth() + 1).toString().slice(-2);
    }
    else
    {
          month =  (today.getMonth() + 1).toString().slice(-2);
    }
    let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
    if (typeof (this.commaSeperatedReqType) == "undefined" || this.commaSeperatedReqType == '') {
      this.toastr.error('Please select requirement type.');
      this.loader = 'none';
      return false;
    }
    
    if (this.regionSelect.selectedItems.length > 0) {
      region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
    }
    else {
      this.toastr.error('Please select region.');
      this.loader = 'none';
      return false;
    }
  
    this.loader = 'block';
    if (this.commaSeperatedSbus == undefined) {
      this.commaSeperatedSbus = '';
    }
    if (this.commaSeperatedDivisions == undefined) {
      this.commaSeperatedDivisions = '';
    }
    if (this.commaSeperatedZones == undefined) {
      this.commaSeperatedZones = '';
    } if (this.commaSeperatedRegions == undefined) {
      this.commaSeperatedRegions = '';
    }
    if (this.commaSeperatedRoleCode == undefined) {
      this.commaSeperatedRoleCode = '';
    }
    if (this.commaSeperatedEmployees == undefined) {
      this.commaSeperatedEmployees = '';
    }
    if (this.commaSeperatedProduct == undefined) {
      this.commaSeperatedProduct = '';
    }
    let designation = Array.prototype.map.call(this.designSelect.selectedItems, function (item) { return item.text; }).join(",");
    this.demoRequestModel.UserId = this.userId;
    this.demoRequestModel.UserName=this.userName;
    this.demoRequestModel.RoleId = this.roleId;
    this.demoRequestModel.SBUCode = this.commaSeperatedSbus;
    this.demoRequestModel.DivisionCode = this.commaSeperatedDivisions;
    this.demoRequestModel.ZoneCode = this.commaSeperatedZones;
    this.demoRequestModel.RegionCode = this.commaSeperatedRegions;
    // this.demoRequestModel.ReqType = this.commaSeperatedReqType;
    this.demoRequestModel.ReqType = Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.text; }).join(",");
    // let year = Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.text; }).join(",");
    this.demoRequestModel.UserRole = this.commaSeperatedRoleCode
    this.demoRequestModel.SelectedEmplyoeeName = this.commaSeperatedEmployees
    this.demoRequestModel.SelectedStatus = this.commaSeperatedStatus
    this.demoRequestModel.Product = this.commaSeperatedProduct
    this.demoRequestModel.Designation = designation;
    this.demoRequestModel.Year = year;
    if(document.getElementsByClassName('mobile-hide-add').length==0){
    this.demoSampleAllocationService.downloadExcel(this.demoRequestModel)
      .subscribe(
        success => {
          if (success.ok = true) {
            var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })


            
            saveAs(blob, this.selectedReqType + "_" + this.userName + "_" + year + "_DemoSampleAllocation_" + formattedDate + ".xlsx");
          }
          this.loader = 'none';
        },
        err => {
          //  alert("No record found");
          //alert("Some problem occurred while downloading file.");
          this.toastr.error('No record found.');
          this.loader = 'none';

        }
      );
    }else{
      this.demoSampleAllocationService.downloadExcelForMobile(this.demoRequestModel)
      .subscribe((resData: any) => {
        var path=resData.message;
        var a = document.getElementById('anc_mob');
        a.setAttribute("href","api/Documents/DownloadExcelDemoSampleAllocation/"+resData.message);
        let element: HTMLElement=document.getElementById('anc_mob') as HTMLElement;
        element.click();
        //a.click();
        //a.href = resData.message;


        //var blob=new Blob(resData.message);
        this.file.nativeElement.value = '';
        this.loader = 'none';
        //this.getDemoSampleAllocationDetails();
      }, error => {
        this.file.nativeElement.value = '';
        this.loader = 'none';
        this.toastr.error('Some problem occured,please try again later.');
      });

      // .subscribe(
      //   success => {
      //     if (success.ok = true) {
      //       var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })


            
      //       saveAs(blob, this.selectedReqType + "_" + this.userName + "_DemoSampleAllocation_" + formattedDate + ".xlsx");
      //     }
      //     this.loader = 'none';
      //   },
      //   err => {
      //     //  alert("No record found");
      //     //alert("Some problem occurred while downloading file.");
      //     this.toastr.error('No record found.');
      //     this.loader = 'none';

      //   }
      // );
    }

  }

  filesDroppedAdd(files: File[]) {
    ///debugger;
    if (typeof (this.commaSeperatedReqType) == "undefined" || this.commaSeperatedReqType == '') {
      this.toastr.error('Please select requirement type.');
      this.loader = 'none';
      return false;
    }
    this.files = [];
    this.files = files;

    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    let UserId = localStorage.getItem('dsu_userId');
    let fileNameIndex = files[0].name.indexOf('_');
    let fileNameIndexUserName = files[0].name.lastIndexOf('_DemoSampleAllocation');
    let fileNameReqType = files[0].name.substring(0, fileNameIndex);
    let fileNameUserType = files[0].name.substring(fileNameIndex + 1, fileNameIndexUserName);

    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error("Please select valid file type.");
      this.loader = 'none';
      return false;
    }
    if (fileNameReqType != this.commaSeperatedReqType) {
      this.toastr.error("Please select valid req type file.");
      this.loader = 'none';
      return false;
    }
    // console.log(fileNameUserType)
    // console.log(localStorage.getItem('dsu_userName'))

    // if (fileNameUserType != this.userName) {
    //   this.toastr.error("Please select valid file.");
    //   this.loader = 'none';
    //   return false;
    // }
    this.loader = 'block';
    this.document.file = <File>this.files[0];
    this.isSubmitted = "false";
    let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.demoSampleAllocationService.uploadDocument(this.document.file, UserId, this.roleId, this.commaSeperatedReqType, this.isSubmitted,year)
      .subscribe((resData: any) => {
        if (resData.data[0].result == 'FAIL') {
          this.toastr.error(resData.data[0].errordescription);
          this.loader = 'none';
        } else {
          this.toastr.success(resData.data[0].errordescription);
          this.loader = 'none';
        }
        this.file.nativeElement.value = '';
        this.loader = 'none';
        this.getDemoSampleAllocationDetails();
      }, error => {
        this.file.nativeElement.value = '';
        this.loader = 'none';
        this.toastr.error('Some problem occured,please try again later.');
      });

  }
  submitDemoSampleAllocationData() {
    let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    if (this.demoSampleAllocationModel == undefined || this.demoSampleAllocationModel.length == 0 || this.demoSampleAllocationModel == null) {
      this.toastr.error('No data found for submission.');
      this.loader = 'none';
      //this.displayReject = 'none';
      return false;

    }
    this.loader = 'block';
    this.isSubmitted = "true"
    this.displayReject = 'none';
    this.demoSampleAllocationService.submitDemoSampleAllocationData(this.demoSampleAllocationModel, this.userId, this.roleId, this.commaSeperatedReqType, this.isSubmitted,year)
      .subscribe((resData: any) => {

        if (resData.data[0].result == 'FAIL') {
          this.toastr.error(resData.data[0].errordescription);
          this.defaultValue = 'none';
          this.loader = 'none';
        } else {
          this.toastr.success(resData.data[0].errordescription);
          this.defaultValue = 'none';
          this.loader = 'none';
        }
        this.file.nativeElement.value = '';
        this.displayReject = 'none';
        this.loader = 'none';
        this.getDemoSampleAllocationDetails();

        this.loader = 'none';
      }, error => {
        this.file.nativeElement.value = '';
        this.loader = 'none';
        this.toastr.error('Some problem occured,please try again later.');
      });


  }
  closePopup(commentModal: string) {
    this.displayReject = 'none';
    this.displayEdit = 'none';
  }
  openCommentPopup() {
    this.displayReject = 'block';
  }
  resetData() {
    this.defaultValue = 'none';
    this.demoSampleAllocationModel = [];
    this.model = [];
    if (this.requirmentType != undefined) {
      this.requirmentType.selectedItems = [];
    }
    if (this.sbu != undefined) {
      this.sbu.selectedItems = [];
    }
    if (this.division != undefined) {
      this.division.selectedItems = [];
    }
    if (this.zone != undefined) {
      this.zone.selectedItems = [];
    }
    if (this.regionSelect != undefined) {
      this.regionSelect.selectedItems = [];
    }
    if (this.roleCodeModel != undefined) {
      this.roleCodeModel.selectedItems = [];
    }
    if (this.employeeSelect != undefined) {
      this.employeeSelect.selectedItems = [];
    }
    if (this.productSelect != undefined) {
      this.productSelect.selectedItems = [];
    }



  }

  EditRow(stock: any, index: number) {
    //console.log(stock);
    
    this.loader = 'block';
    
    let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.demoSampleAllocationService.GetDemoSampleData(stock.allocationId, stock.requirementType,year)
      .subscribe((resData: any) => {
        if (resData.status && resData.data != null) {
          this.editStockIn.requestNo = resData.data.requestNo;
          this.editStockIn.rowNum = resData.data.rowNum;
          this.editStockIn.allocationId = stock.allocationId;
          // this.editStockIn.ammName = resData.data.ammName;
          // this.editStockIn.product = resData.data.product;
          // this.editStockIn.miomdoUserID = resData.data.miomdoUserID;
          // this.editStockIn.nameOfMIOMDO = resData.data.nameOfMIOMDO;
          // this.editStockIn.designation = resData.data.designation;
          // this.editStockIn.mieUserID = resData.data.mieUserID;
          // this.editStockIn.nameOfMIE = resData.data.nameOfMIE;
          // this.editStockIn.ammName = stock.ammName;
          this.editStockIn.ammName =resData.data.ammName;
          //resData.data.ammName
          this.editStockIn.product = stock.product;
          this.editStockIn.miomdoUserID = resData.data.miomdoUserID;
          // this.editStockIn.nameOfMIOMDO = stock.nameOfMIOMDOng ;
          this.editStockIn.nameOfMIOMDO = resData.data.nameOfMIOMDO;
          //resData.data.nameOfMIOMDO
          this.editStockIn.designation = stock.designation;
          this.editStockIn.mieUserID = stock.mieUserID;
          this.editStockIn.nameOfMIE =stock.nameOfMIE;

          this.editStockIn.packSize = resData.data.packsize;
          this.editStockIn.packSizeInt = resData.data.packSizeInt;
          this.editStockIn.jan = resData.data.jan;
          this.editStockIn.feb = resData.data.feb;
          this.editStockIn.mar = resData.data.mar;
          this.editStockIn.apr = resData.data.apr;
          this.editStockIn.may = resData.data.may;
          this.editStockIn.jun = resData.data.jun;
          this.editStockIn.jul = resData.data.jul;
          this.editStockIn.aug = resData.data.aug;
          this.editStockIn.sep = resData.data.sep;
          this.editStockIn.oct = resData.data.oct;
          this.editStockIn.nov = resData.data.nov;
          this.editStockIn.dec = resData.data.dec;
          this.sumOfPackOfOneRow = this.editStockIn.jan+this.editStockIn.feb+this.editStockIn.mar+this.editStockIn.apr
          +this.editStockIn.may+this.editStockIn.jun+this.editStockIn.jul+this.editStockIn.aug+this.editStockIn.sep
          +this.editStockIn.oct+this.editStockIn.nov+this.editStockIn.dec;
          this.editStockIn.reqType = resData.data.requirementType;
          this.editStockIn.totalQtyToDispatch = resData.data.totalQTYToDispatch;
          this.editStockIn.totalRemainingQTY = resData.data.totalRemainingQTY;
          this.totalRemainingQuantity = this.editStockIn.totalRemainingQTY;
          this.editStockIn.remaining = resData.data.totalRemaining;
          this.editStockIn.status = resData.data.status;
          // this.editStockIn.allocatedDate = this.datePipe.transform(resData.data.allocatedDate, 'dd/MMM/yyyy hh:mm a');
          // this.editStockIn.dispatchedDate = this.datePipe.transform(resData.data.dispatchedDate, 'dd/MMM/yyyy hh:mm a');
          this.editStockIn.allocatedDate = this.datePipe.transform(resData.data.allocatedDate, 'dd/MMM/yyyy');
          this.editStockIn.dispatchedDate = this.datePipe.transform(resData.data.dispatchedDate, 'dd/MMM/yyyy');
          // this.editStockIn.oldtotalQtyToDispatch = resData.data.totalQTYToDispatch;
          //this.editStockIn.oldtotalQtyToDispatch = resData.data.totalRemainingQTY.toFixed(2);
          this.editStockIn.oldtotalQtyToDispatch = parseFloat(resData.data.finalApprovedQTY).toFixed(2);
          




          if (resData.data.packsize.indexOf("LTR") !== -1 || resData.data.packsize.indexOf("LT") !== -1 || resData.data.packsize.indexOf("KG") !== -1) {
           // this.editStockIn.remainingQtyPack = parseInt(Math.ceil(parseFloat(resData.data.totalRemainingQTY) / parseInt(resData.data.packSizeInt)).toString());
            this.editStockIn.remainingQtyPack = parseInt((parseFloat(resData.data.totalRemainingQTY) / parseInt(resData.data.packSizeInt)).toString());
          }
          else {
       //     this.editStockIn.remainingQtyPack = parseInt(Math.ceil(parseFloat(resData.data.totalRemainingQTY) * 1000 / parseInt(resData.data.packSizeInt)).toString());
            this.editStockIn.remainingQtyPack = parseInt((parseFloat(resData.data.totalRemainingQTY) * 1000 / parseInt(resData.data.packSizeInt)).toString());
          }

          this.displayEdit = "block";
        }
        else {
          //this.toastr.error('Please submit the demo sample allocation.');
        }


        this.loader = 'none';
      }, error => {
        this.file.nativeElement.value = '';
        this.loader = 'none';
        this.toastr.error('Some problem occured,please try again later.');
      });

    // console.log(index)
    // console.log(stock)
    // console.log(this.model)
    // this.editStockIn = stock;
    // this.tempStock = { ...stock };
    // // this.editStockIn.push(stock);
    // //this.editStockIn = this.DeepCopy(stock);
    // console.log(this.editStockIn)
    // this.editStockIn.rowNum = index;
    // this.editStockIn.ammName = this.editStockIn.ammName;
    // this.editStockIn.product = this.editStockIn.product;
    // this.editStockIn.miomdoUserID = this.editStockIn.miomdoUserID;
    // this.editStockIn.nameOfMIOMDO = this.editStockIn.nameOfMIOMDO;
    // this.editStockIn.designation = this.editStockIn.designation;
    // this.editStockIn.mieUserID = this.editStockIn.mieUserID;
    // this.editStockIn.nameOfMIE = this.editStockIn.nameOfMIE;
    // this.editStockIn.packSize = this.editStockIn.packSize;
    // this.editStockIn.jan = this.editStockIn.jan;
    // this.editStockIn.feb = this.editStockIn.feb;
    // this.editStockIn.mar = this.editStockIn.mar;
    // this.editStockIn.apr = this.editStockIn.apr;
    // this.editStockIn.may = this.editStockIn.may;
    // this.editStockIn.jun = this.editStockIn.jun;
    // this.editStockIn.jul = this.editStockIn.jul;
    // this.editStockIn.aug = this.editStockIn.aug;
    // this.editStockIn.sep = this.editStockIn.sep;
    // this.editStockIn.oct = this.editStockIn.oct;
    // this.editStockIn.nov = this.editStockIn.nov;
    // this.editStockIn.dec = this.editStockIn.dec;
    // this.editStockIn.totalQtyToDispatch = this.editStockIn.totalQtyToDispatch;
    // // if (this.editStockIn.totalRemainingQTY == 0) {
    // //   this.editStockIn.totalRemainingQTY = this.editStockIn.finalApprovedQTY;
    // // } else {
    // //   this.editStockIn.totalRemainingQTY = this.editStockIn.totalRemainingQTY;
    // // }
    // this.editStockIn.totalRemainingQTY = this.editStockIn.totalRemainingQTY;
    // this.originalRemainQTY = this.editStockIn.totalRemainingQTY;
    // this.editStockIn.status = this.editStockIn.status;
    // this.editStockIn.allocatedDate = this.datePipe.transform(this.editStockIn.allocatedDate, 'dd/MMM/yyyy hh:mm a');
    // this.editStockIn.dispatchedDate = this.datePipe.transform(this.editStockIn.dispatchedDate, 'dd/MMM/yyyy hh:mm a');

  }
  DeepCopy(obj: any): any {
    let clonedObject;

    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
    if (obj instanceof Array) {
      clonedObject = [];
      for (let i = 0; i < obj.length; i++) {
        clonedObject[i] = this.DeepCopy(obj[i]);
      }
      return clonedObject;
    }
    if (obj instanceof Date) {
      clonedObject = new Date(obj.valueOf());
      return clonedObject;
    }
    if (obj instanceof RegExp) {
      clonedObject = RegExp(obj.source, obj.flags);
      return clonedObject;
    }
    if (obj instanceof Object) {
      clonedObject = new obj.constructor();
      for (const attr in obj) {
        if (obj.hasOwnProperty(attr)) {
          clonedObject[attr] = this.DeepCopy(obj[attr]);
        }
      }
      return clonedObject;
    }
  }
  saveDemoSampleAllocationData() {
    let sum = 0;
      const tableElement = this.table.nativeElement;
    // const inputs = tableElement.querySelectorAll('input[type="number"]');
    //const inputs = Array.from(tableElement.querySelectorAll('input[type="number"]')) as HTMLInputElement[];
    const inputs = Array.from(document.querySelectorAll('input.submitdisable')) as HTMLInputElement[];
    sum = inputs
      .filter((input) => !input.disabled) 
      .reduce((acc, input) => acc + (parseFloat(input.value) || 0), 0);
    console.log('Sum:', sum);
    if(sum===0)
    {
      this.toastr.error('Please Enter Number of Packs.');
      this.loader = 'none';
      return;
    }
    let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    
    this.demoSampleAllocationModel = this.demoSampleAllocationModel.filter(x => x.allocationId==this.editStockIn.allocationId); 

    this.demoSampleAllocationModel[0].jan = this.editStockIn.jan;
    this.demoSampleAllocationModel[0].feb = this.editStockIn.feb;
    this.demoSampleAllocationModel[0].mar = this.editStockIn.mar;
    this.demoSampleAllocationModel[0].apr = this.editStockIn.apr;
    this.demoSampleAllocationModel[0].may = this.editStockIn.may;
    this.demoSampleAllocationModel[0].jun = this.editStockIn.jun;
    this.demoSampleAllocationModel[0].jul = this.editStockIn.jul;
    this.demoSampleAllocationModel[0].aug = this.editStockIn.aug;
    this.demoSampleAllocationModel[0].sep = this.editStockIn.sep;
    this.demoSampleAllocationModel[0].oct = this.editStockIn.oct;
    this.demoSampleAllocationModel[0].nov = this.editStockIn.nov;
    this.demoSampleAllocationModel[0].dec = this.editStockIn.dec;
    this.demoSampleAllocationModel[0].totalQtyToDispatch = this.editStockIn.totalQtyToDispatch;
    this.demoSampleAllocationModel[0].ammName = this.editStockIn.ammName;
    this.demoSampleAllocationModel[0].miomdoUserID= this.editStockIn.miomdoUserID
    this.demoSampleAllocationModel[0].totalRemainingQTY = parseFloat(this.editStockIn.totalRemainingQTY).toFixed(2);

    if (this.demoSampleAllocationModel == undefined || this.demoSampleAllocationModel.length == 0 || this.demoSampleAllocationModel == null) {
      this.toastr.error('No data found for submission.');
      this.loader = 'none';
      //this.displayReject = 'none';
      return false;

    }
    this.loader = 'block';
    this.isSubmitted = "edit"
    this.displayReject = 'none';
    this.displayEdit = 'none';

    this.demoSampleAllocationModel[0].rowNum = this.editStockIn.allocationId;
    this.demoSampleAllocationModel[0].ammName = this.editStockIn.ammName;

    // this.demoSampleAllocationService.UpdateSubmitDemoSampleAllocationData(this.editStockIn.requestNo, this.editStockIn.product, this.demoSampleAllocationModel[0].region,this.demoSampleAllocationModel[0].miomdoUserID)
    //   .subscribe((resData: any) => {
    //     if (resData.data == 1) {
          //this.demoSampleAllocationService.submitDemoSampleAllocationData(this.editStockIn, this.userId, this.roleId, this.commaSeperatedReqType, this.isSubmitted,year)
          //  this.demoSampleAllocationService.submitDemoSampleAllocationData(this.demoSampleAllocationModel, this.userId, this.roleId, this.commaSeperatedReqType, this.isSubmitted,year)
          

          this.demoSampleAllocationService.submitDemoSampleAllocationData(this.demoSampleAllocationModel, this.userId, this.roleId, this.commaSeperatedReqType, this.isSubmitted,year)
            .subscribe((resData: any) => {
              if (resData.status) {
                if(resData.message== "Success")
                {
                  this.toastr.success("Allocation done successfully");
                  this.defaultValue = 'none';
                  this.loader = 'none';

                }
                else{
                  this.toastr.error(resData.message);
                  this.defaultValue = 'none';
                  this.loader = 'none';
                }
                
              } else {
                this.toastr.success(resData.message);
                this.defaultValue = 'none';
                this.loader = 'none';
              }
              this.getDemoSampleAllocationDetails();
              this.file.nativeElement.value = '';
              this.displayReject = 'none';
              this.loader = 'none';

            }, error => {
              this.file.nativeElement.value = '';
              this.loader = 'none';
              this.toastr.error('Some problem occured,please try again later.');
            });
        // } else {
        //   this.toastr.error('Some problem occured,please try again later.');
        //   this.defaultValue = 'none';
        //   this.loader = 'none';

        //   this.getDemoSampleAllocationDetails();
        //   this.file.nativeElement.value = '';
        //   this.displayReject = 'none';
        //   this.loader = 'none';
        // }


      // }, error => {
      //   this.file.nativeElement.value = '';
      //   this.loader = 'none';
      //   this.toastr.error('Some problem occured,please try again later.');
      // });


  }
  @ViewChild('poptable') table!: ElementRef;
  textChange(newValue, i, key, previousValue) {
    let nwValue = newValue.target.value;
    if (nwValue == '') {
      nwValue = 0;
    }
    
    let item = this.model.find(obj => obj.rowNum === parseInt(i, 10)).product;
    let totalRemaining= this.totalNoOfPacks.find(obj => obj.Product === item).Packs;
    
    this.totalDispatchedQty(nwValue, i, totalRemaining)
  }
  totalDispatchedQty(nwValue: any, index: any, remaining: any) {

    let packSize = this.editStockIn.packSize;
    // let packSizeInt = parseInt(this.editStockIn.packSizeInt);    Commented for pcksize in decimal
    let packSizeInt = parseFloat(this.editStockIn.packSizeInt);

    if (this.editStockIn.jan == null || this.editStockIn.jan == 'undefined') {
      this.editStockIn.jan = 0;
    }
    else if (this.editStockIn.feb == null || this.editStockIn.feb == 'undefined') {
      this.editStockIn.feb = 0;
    }
    else if (this.editStockIn.mar == null || this.editStockIn.mar == 'undefined') {
      this.editStockIn.mar = 0;
    }
    else if (this.editStockIn.apr == null || this.editStockIn.apr == 'undefined') {
      this.editStockIn.apr = 0;
    }
    else if (this.editStockIn.may == null || this.editStockIn.may == 'undefined') {
      this.editStockIn.may = 0;
    }
    else if (this.editStockIn.jun == null || this.editStockIn.jun == 'undefined') {
      this.editStockIn.jun = 0;
    }
    else if (this.editStockIn.jul == null || this.editStockIn.jul == 'undefined') {
      this.editStockIn.jul = 0;
    }
    else if (this.editStockIn.aug == null || this.editStockIn.aug == 'undefined') {
      this.editStockIn.aug = 0;
    }
    else if (this.editStockIn.sep == null || this.editStockIn.sep == 'undefined') {
      this.editStockIn.sep = 0;
    }
    else if (this.editStockIn.oct == null || this.editStockIn.oct == 'undefined') {
      this.editStockIn.oct = 0;
    }
    else if (this.editStockIn.nov == null || this.editStockIn.nov == 'undefined') {
      this.editStockIn.nov = 0;
    }
    else if (this.editStockIn.dec == null || this.editStockIn.dec == 'undefined') {
      this.editStockIn.dec = 0;
    }


    let totalPacksToDispatch= (parseFloat(this.editStockIn.jan) + parseFloat(this.editStockIn.feb) + parseFloat(this.editStockIn.mar) +
        parseFloat(this.editStockIn.apr) + parseFloat(this.editStockIn.may) + parseFloat(this.editStockIn.jun) +
        parseFloat(this.editStockIn.jul) + parseFloat(this.editStockIn.aug) + parseFloat(this.editStockIn.sep) +
        parseFloat(this.editStockIn.oct) + parseFloat(this.editStockIn.nov) + parseFloat(this.editStockIn.dec));


    // if (packSize.indexOf("LTR") !== -1 || packSize.indexOf("LT") !== -1 || packSize.indexOf("KG") !== -1) {
    //   //this.editStockIn.totalRemainingQTY = parseFloat(remaining) - parseFloat(this.editStockIn.totalQtyToDispatch);
    //   this.editStockIn.totalRemainingQTY = remaining - parseInt(nwValue);
    //   this.editStockIn.remainingQtyPack = this.editStockIn.totalRemainingQTY;
      
    // }
    // else {
    //   // let valuePackRemaining = remaining * 1000 / 25;
    //   let valuePack = parseInt(nwValue) * packSizeInt / 1000;
    //   this.editStockIn.totalRemainingQTY = remaining - valuePack;
    //   this.editStockIn.remainingQtyPack = this.editStockIn.remainingQtyPack -parseInt(nwValue)
    // }
    if(totalPacksToDispatch > this.sumOfPackOfOneRow){
      remaining = (totalPacksToDispatch - this.sumOfPackOfOneRow) + remaining;
    }else if(totalPacksToDispatch < this.sumOfPackOfOneRow){
      remaining = remaining - (this.sumOfPackOfOneRow - totalPacksToDispatch)
    }
    // this.editStockIn.totalRemainingQTY = remaining - totalPacksToDispatch * packSizeInt;
    // this.editStockIn.remainingQtyPack = remaining/packSizeInt - totalPacksToDispatch;

    if (packSize.indexOf("LTR") !== -1 || packSize.indexOf("LT") !== -1 || packSize.indexOf("KG") !== -1) {
      this.editStockIn.remainingQtyPack = parseInt(Math.ceil(parseFloat(this.editStockIn.oldtotalQtyToDispatch) / packSizeInt).toString()) - remaining;
      this.editStockIn.totalRemainingQTY = this.editStockIn.remainingQtyPack * packSizeInt;
    }
    else {
      this.editStockIn.remainingQtyPack = parseInt(Math.ceil(parseFloat(this.editStockIn.oldtotalQtyToDispatch) * 1000 / packSizeInt).toString()) - remaining;
      this.editStockIn.totalRemainingQTY = ((this.editStockIn.remainingQtyPack * packSizeInt)/1000).toString();
    }

    this.editStockIn.totalRemainingQTY = parseFloat(this.editStockIn.totalRemainingQTY).toFixed(2);

    // if (packSize.indexOf("LTR") !== -1 || packSize.indexOf("LT") !== -1 || packSize.indexOf("KG") !== -1) {
    //   this.editStockIn.remainingQtyPack = this.editStockIn.totalRemainingQTY;
    // }
    // else {
    //   //this.editStockIn.remainingQtyPack =  ((this.editStockIn.totalRemainingQTY * 1000)/packSizeInt).toFixed(2);
    //   this.editStockIn.remainingQtyPack = (Math.floor((this.editStockIn.totalRemainingQTY * 1000) / packSizeInt));
    // }

    if (this.editStockIn.totalRemainingQTY < 0) {
      this.toastr.error('Total No. of Packs to Dispatch QTY can not be greater then Remaining QTY');
      this.isPopDisable = true;
      return false;
    }
    else {
      this.isPopDisable = false;
    }
  }

  isAlphaNumeric(event: any) {
    var newKeyCode = event.keyCode;
    return ((newKeyCode > 64 && newKeyCode < 91) || (newKeyCode > 96 && newKeyCode < 123) || (newKeyCode == 8 || newKeyCode == 32) || (newKeyCode >= 48 && newKeyCode <= 57) || newKeyCode == 59);
  }


  // Start :For Pagination
  // setPage(page: number, pageSize: number) {
  //   // get pager object from service
  //   if (this.modalSetting == 0) {
  //     this.pager = this._pagerService.getPager(this.demoSampleAllocationModel.length, page, pageSize);
  //     this.model = this.demoSampleAllocationModel.slice(this.pager.startIndex, this.pager.endIndex + 1);
  //   }
  //   else {
  //     if (this.modalSetting == 1) {
  //       this.pager = this._pagerService.getPager(this.demoSampleAllocationModel.length, page, pageSize);
  //       this.model = this.demoSampleAllocationModel.slice(this.pager.startIndex, this.pager.endIndex + 1);
  //     }
  //     else {
  //       this.pager = this._pagerService.getPager(this.modelDepandent.length, page, pageSize);
  //       this.model = this.modelDepandent.slice(this.pager.startIndex, this.pager.endIndex + 1);
  //     }
  //   }
  //   // get current page of items
  // }
  // onSelectPaging(val: any): void {
  //   if (val == "0") {
  //     this.model = this.demoSampleAllocationModel;
  //     this.pageSetting = 10;
  //   }
  //   else {
  //     this.pageSetting = val == "1" ? 20 : 30;
  //   }
  //   this.modalSetting = 0;
  //   this.setPage(1, this.pageSetting);
  // }
  // END :For Pagination
}